import { Page, Spinner } from "@patternfly/react-core";
import { useEffect } from 'react';
import style from "./App.module.css";

// import { Header } from "@keycloak/keycloak-account-ui";
import { Header } from "./Header";
import { Suspense } from "react";
import { Outlet } from "react-router-dom";
// import { PageNav } from "@keycloak/keycloak-account-ui";
import { PageNav } from "./PageNav";

function App() {
  
  useEffect(() => {
    document.documentElement.classList.remove('pf-v5-theme-dark'); // Force light theme
    document.documentElement.style.colorScheme = 'light';
  }, []);

  return (
    <Page className={style.headerLogo} header={<Header />} sidebar={<PageNav />} isManagedSidebar>
      <Suspense fallback={<Spinner />}>
        <Outlet />
      </Suspense>
    </Page>
  );
}

export default App;
